export default __webpack_public_path__ + "static/media/cern-italic.756ca4b7.eot";